import React, { Fragment } from "react";
import PageBodyWrapper from "root/PageBodyWrapper";
import { ErrorBoundary } from "react-error-boundary";
import FallbackComponent from "root/FallbackComponent";

import SystemAdminPanel from "root/SystemAdmin/SystemAdminPanel";

const SystemAdminPageBody = () =>
{
    return (
        <ErrorBoundary  FallbackComponent={FallbackComponent}>
            <PageBodyWrapper title='Activities'>
                <div className='grid-page-layout single'>
                    <SystemAdminPanel image={'app/style/image/manage.svg'} title='End of Year' color='var(--s360-icon-blue)' links={[]}/>
                </div>
            </PageBodyWrapper>
        </ErrorBoundary>
    )
}

export default SystemAdminPageBody;